import { VForm } from 'vuetify/lib/components/VForm';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VForm,_vm._b({ref:"formRef",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},'v-form',_vm.$attrs,false),[_vm._t("default",null,{"valid":_vm.valid})],2)}
var staticRenderFns = []

export { render, staticRenderFns }